import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  capitalizeFirstLetters,
  convertToPersian,
  formatPrice,
} from "../Functions/TextTransform";

const capitalizeWords = (str) => {
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default function FilteredLeft({
  titleProduct,
  handleChange,
  priceLevels,
  checkedItems,
  colorFilter,
  setCheckedItems,
  checkedPriceLevels,
  setCheckedPriceLevels,
  selectedItems,
  productGroups,
  setSelectedItems,
  syncProductLayout = false,
}) {
  const { i18n } = useTranslation();
  const [openAccordions, setOpenAccordions] = useState({});
  const [showMore, setShowMore] = useState(false);
  const [showMoreFilter, setShowMoreFilter] = useState({});
  const [isScrolled, setIsScrolled] = useState(false);
  const toggleAccordion = (index) => {
    setOpenAccordions((prevAccordions) => ({
      ...prevAccordions,
      [index]: !prevAccordions[index],
    }));
  };

  const toggleShowMore = () => setShowMore((prev) => !prev);

  const toggleShowMore2 = (index) => {
    setShowMoreFilter((prevShowMoreFilter) => ({
      ...prevShowMoreFilter,
      [index]: !prevShowMoreFilter[index],
    }));
  };

  const handleCheckboxChange = (item, category) => {
    const type =
      checkedItems[item.ColorId] ||
      checkedPriceLevels[item.ProductPriceLevelId] ||
      checkedItems[item.Value]
        ? 0
        : 1;

    if (category === "colors") {
      setCheckedItems((prev) => {
        const newCheckedItems = { ...prev };
        newCheckedItems[item.ColorId] = !prev[item.ColorId];
        return newCheckedItems;
      });
    } else if (category === "priceLevels") {
      setCheckedPriceLevels((prev) => {
        const newCheckedPriceLevels = { ...prev };
        newCheckedPriceLevels[item.ProductPriceLevelId] = !prev[item.ProductPriceLevelId];
        return newCheckedPriceLevels;
      });
    } else if (category === "Material") {
      setCheckedItems((prev) => {
        const newCheckedPriceLevels = { ...prev };
        newCheckedPriceLevels[item.Value] = !prev[item.Value];
        return newCheckedPriceLevels;
      });
    }

    handleChange(item, category, type);
  };

  const isColorChecked = (UrlName) => {
    return selectedItems.some((item) => item.UrlName === UrlName);
  };

  const isMaterialChecked = (UrlName) => {
    return selectedItems.some((item) => item.UrlName === UrlName);
  };

  const isPriceLevelChecked = (UrlName) => {
    return selectedItems.some((item) => item.UrlName === UrlName);
  };

  const handleCheckbox = (item) => {
    setSelectedItems((prevSelectedItems) => {
      const isChecked = selectedItems.some((selected) => selected.UrlName === item.UrlName);
      const type = isChecked ? 2 : 3;
      handleChange(item, "product", type);
      if (isChecked) {
        return [...prevSelectedItems.filter((selected) => selected.UrlName !== item.UrlName)];
      } else {
        return [...prevSelectedItems, item];
      }
    });
  };

  const isCheckName = (productGroupENName) => {
    return selectedItems.some((item) => item.UrlName === productGroupENName);
  };
  const filterClass = i18n.language === "en" ? "product_filters_en" : "";
  useEffect(() => {
    if (syncProductLayout) {
      setIsScrolled(false);
      return undefined;
    }

    const handleScroll = () => {
      if (window.scrollY > 220) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [syncProductLayout]);
  const materialCategory = titleProduct.find((item) => item.FilterId === 122);

  let lengthMaterial = 0;
  if (materialCategory) {
    const uniqueValues = new Set();
    lengthMaterial = materialCategory.Values.filter((value) => {
      if (value.Count > 0 && !uniqueValues.has(value.Value)) {
        uniqueValues.add(value.Value);
        return true;
      }
      return false;
    }).length;
  }
  let materialFilter = titleProduct?.filter((item) => item.FilterId === 122);
  let colorFilters = colorFilter
    ?.filter((color) => color.Count > 0)
    .slice(0, showMore ? colorFilter.length : 4);
  let colorFiltersLength = colorFilter?.filter((color) => color.Count > 0);
  let priceLevel = priceLevels
    ?.filter((color) => color.Count > 0)
    .slice(0, showMore ? priceLevels.length : 4);
  let priceLevelLength = priceLevels?.filter((color) => color.Count > 0);
  let typeGroup = productGroups
    ?.filter((color) => color.Count >= 0)
    .slice(0, showMore ? productGroups.length : 4);
  let typeGroupLength = productGroups?.filter((color) => color.Count >= 0);

  return (
    <div
      className={`product_filters_fixed ${
        syncProductLayout ? "collection_page_sidebar_sticky" : isScrolled ? "scrool_top_left" : ""
      }`}
      style={syncProductLayout ? undefined : { width: "21rem", height: "18.5rem" }}
    >
      {/* بخش تایپ */}
      <div className="page_filterLeft_container">
        <div className={`page_filterLeft_header ${filterClass}`} onClick={() => toggleAccordion(4)}>
          <span>{i18n.language === "fa" ? "نوع محصول" : "Type"}</span>
          <span className="page_filterLeft_toggle">{openAccordions[4] ? "-" : "+"}</span>
        </div>

        {openAccordions[4] && (
          <div style={{ padding: "10px" }}>
            {typeGroup.map((color, index) => {
              return (
                <div key={index + 1} className="page_filterLeft_valueItem">
                  <div style={{ height: "1rem" }}>
                    <input
                      type="checkbox"
                      id={color.ProductGroupENName}
                      name={color.ProductGroupENName}
                      style={{
                        width: "1rem",
                        height: "1rem",
                        display: "block",
                        cursor: "pointer",
                        appearance: "none",
                        border: "1px solid #333",
                        backgroundColor: checkedItems[color.ProductGroupENName]
                          ? ""
                          : "transparent",
                      }}
                      checked={isCheckName(color.ProductGroupENName)}
                      onChange={() => handleCheckbox(color)}
                    />
                    {isCheckName(color.ProductGroupENName) && (
                      <svg
                        viewBox="0 0 24 24"
                        style={{
                          width: "0.8rem",
                          height: "0.8rem",
                          position: "relative",
                          top: "-1.2rem",
                          left: "0",
                          pointerEvents: "none",
                        }}
                      >
                        <polyline
                          points="20 6 9 17 4 12"
                          fill="none"
                          stroke="#000"
                          strokeWidth="2"
                        />
                      </svg>
                    )}
                  </div>
                  <div>
                    <label htmlFor={color.ProductGroupENName} className="page_filterLeft_label 1">
                      <span>
                        {i18n.language === "fa"
                          ? color.ProductGroupName
                          : capitalizeFirstLetters(color.ProductGroupENName)}
                      </span>
                    </label>
                  </div>
                </div>
              );
            })}
            {typeGroupLength.length > 4 && (
              <div className="page_filterLeft_div">
                <button onClick={toggleShowMore} className="page_filterLeft_btn">
                  {showMore
                    ? i18n.language === "fa"
                      ? "بستن"
                      : "Show Less"
                    : i18n.language === "fa"
                    ? "نمایش بیشتر"
                    : "Show More"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      {/* آکاردئون‌های دیگر */}
      {materialFilter?.map((item, index) => (
        <div key={item.FilterId} className="page_filterLeft_container">
          <div
            className={`page_filterLeft_header ${filterClass}`}
            onClick={() => toggleAccordion(index + 2)}
          >
            <span>{i18n.language === "fa" ? item.Title : capitalizeWords(item.EnTitle)}</span>
            <span className="page_filterLeft_toggle">{openAccordions[index + 2] ? "-" : "+"}</span>
          </div>

          {openAccordions[index + 2] && (
            <div style={{ padding: "10px" }}>
              {item.Values.filter(
                (value, index, self) =>
                  value.Count > 0 && index === self.findIndex((v) => v.EnTitle === value.EnTitle)
              )
                .slice(0, showMoreFilter[index + 1] ? item.Values.length : 4)
                .map((valueItem, index) => (
                  <div key={index + 10000} className="page_filterLeft_valueItem">
                    <div style={{ height: "1rem" }}>
                      <input
                        type="checkbox"
                        id={valueItem.Value}
                        name={valueItem.ValueName}
                        style={{
                          width: "1rem",
                          height: "1rem",
                          display: "block",
                          cursor: "pointer",
                          appearance: "none",
                          border: "1px solid #333",
                          backgroundColor: checkedItems[valueItem.Value] ? "" : "transparent",
                        }}
                        checked={isMaterialChecked(valueItem.UrlName)}
                        onChange={() => handleCheckboxChange(valueItem, item.FilterName)}
                      />
                      {isMaterialChecked(valueItem.UrlName) && (
                        <svg
                          viewBox="0 0 24 24"
                          style={{
                            width: "0.8rem",
                            height: "0.8rem",
                            position: "relative",
                            top: "-1.2rem",
                            left: "0",
                            pointerEvents: "none",
                          }}
                        >
                          <polyline
                            points="20 6 9 17 4 12"
                            fill="none"
                            stroke="#000"
                            strokeWidth="2"
                          />
                        </svg>
                      )}
                    </div>
                    <div>
                      <label htmlFor={valueItem.Value} className="page_filterLeft_label 2">
                        <span>
                          {i18n.language === "fa"
                            ? valueItem.Title
                            : capitalizeFirstLetters(valueItem.EnTitle)}
                        </span>
                      </label>
                    </div>
                  </div>
                ))}
              {lengthMaterial > 4 && (
                <div className="page_filterLeft_div">
                  <button
                    onClick={() => toggleShowMore2(index + 1)}
                    className="page_filterLeft_btn"
                  >
                    {showMoreFilter[index + 1]
                      ? i18n.language === "fa"
                        ? "بستن"
                        : "Show Less"
                      : i18n.language === "fa"
                      ? "نمایش بیشتر"
                      : "Show More"}
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      ))}

      {/* بخش رنگ‌ها */}
      <div className="page_filterLeft_container">
        <div
          className={`page_filterLeft_header ${filterClass}`}
          onClick={() => toggleAccordion(0)} // استفاده از 0 برای رنگ‌ها
        >
          <span>{i18n.language === "fa" ? "رنگ‌ها" : "Color"}</span>
          <span className="page_filterLeft_toggle">{openAccordions[0] ? "-" : "+"}</span>
        </div>

        {openAccordions[0] && (
          <div style={{ padding: "10px" }}>
            {colorFilters.map((color, index) => {
              return (
                <div key={index + 1000} className="page_filterLeft_valueItem">
                  <div style={{ height: "1rem" }}>
                    <input
                      type="checkbox"
                      id={color.ColorENName}
                      name={color.ColorENName}
                      style={{
                        width: "1rem",
                        height: "1rem",
                        display: "block",
                        cursor: "pointer",
                        appearance: "none",
                        border: "1px solid #333",
                        backgroundColor: checkedItems[color.ColorENName] ? "" : "transparent",
                      }}
                      checked={isColorChecked(color.UrlName)}
                      onChange={() => handleCheckboxChange(color, "colors")}
                    />
                    {isColorChecked(color.UrlName) && (
                      <svg
                        viewBox="0 0 24 24"
                        style={{
                          width: "0.8rem",
                          height: "0.8rem",
                          position: "relative",
                          top: "-1.2rem",
                          left: "0",
                          pointerEvents: "none",
                        }}
                      >
                        <polyline
                          points="20 6 9 17 4 12"
                          fill="none"
                          stroke="#000"
                          strokeWidth="2"
                        />
                      </svg>
                    )}
                  </div>
                  <div>
                    <label htmlFor={color.ColorENName} className="page_filterLeft_label 3">
                      <span>
                        {i18n.language === "fa"
                          ? color.ColorName
                          : capitalizeFirstLetters(color.ColorENName)}
                      </span>
                    </label>
                  </div>
                </div>
              );
            })}
            {colorFiltersLength.length > 4 && (
              <div className="page_filterLeft_div">
                <button onClick={toggleShowMore} className="page_filterLeft_btn">
                  {showMore
                    ? i18n.language === "fa"
                      ? "بستن"
                      : "Show Less"
                    : i18n.language === "fa"
                    ? "نمایش بیشتر"
                    : "Show More"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* بخش قیمت ها */}
      <div className="page_filterLeft_container">
        <div className={`page_filterLeft_header ${filterClass}`} onClick={() => toggleAccordion(1)}>
          <span>{i18n.language === "fa" ? "قیمت " : "Price"}</span>
          <span className="page_filterLeft_toggle">{openAccordions[1] ? "-" : "+"}</span>
        </div>

        {openAccordions[1] && (
          <div style={{ padding: "10px" }}>
            {priceLevel.map((color, index) => (
              <div key={index + 100} className="page_filterLeft_valueItem">
                <div style={{ height: "1rem" }}>
                  <input
                    type="checkbox"
                    id={color.ColorENName}
                    name={color.ColorENName}
                    style={{
                      width: "1rem",
                      height: "1rem",
                      display: "block",
                      cursor: "pointer",
                      appearance: "none",
                      border: "1px solid #333",
                      backgroundColor: checkedPriceLevels[color.ColorENName] ? "" : "transparent",
                    }}
                    checked={isPriceLevelChecked(color.UrlName)}
                    onChange={() => handleCheckboxChange(color, "priceLevels")}
                  />
                  {/* {checkedPriceLevels[color.ProductPriceLevelId] && ( */}
                  {isPriceLevelChecked(color.UrlName) && (
                    <svg
                      viewBox="0 0 24 24"
                      style={{
                        width: "0.8rem",
                        height: "0.8rem",
                        position: "relative",
                        top: "-1.2rem",
                        left: "0",
                        pointerEvents: "none",
                      }}
                    >
                      <polyline points="20 6 9 17 4 12" fill="none" stroke="#000" strokeWidth="2" />
                    </svg>
                  )}
                </div>
                <div>
                  <label htmlFor={color.ColorENName} className="page_filterLeft_label 4">
                    <span>
                      {i18n.language === "fa"
                        ? convertToPersian(formatPrice(color.LevelTitle), "fa")
                        : capitalizeFirstLetters(color.LevelEnTitle)}
                    </span>
                  </label>
                </div>
              </div>
            ))}
            {priceLevelLength.length > 4 && (
              <div className="page_filterLeft_div">
                <button onClick={toggleShowMore} className="page_filterLeft_btn">
                  {showMore
                    ? i18n.language === "fa"
                      ? "بستن"
                      : "Show Less"
                    : i18n.language === "fa"
                    ? "نمایش بیشتر"
                    : "Show More"}
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
